import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";
import Label from "components/general/Label"
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import SportCode from "components/common/SportCode";
import { getDateTimeFormat } from "helpers/utils";

export function Footer({ data }) {

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code) && (<div className='d-flex'><div className='text-start'>{dateComponent}</div></div>)}
            {isLessLiveStatus(data?.result?.status?.code) && (<div className='d-flex'><div className='text-end'><Label data='HeaderBout' /> {numberGame}</div></div>)}
        </>
    )
}

export function CompetitorBlock(competitor) {
    let bold = competitor?.result === undefined ? 'fw-bold' : ''
    return (
        <div className={'score-competitor-container  d-flex flex-row justify-content-start ' + bold}>
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name'><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} showSeed={true} onlyShortName={true} seed={competitor?.co_seed} screen={competitor.screen} /> </div>
        </div>
    )
}

export function CompetitorBlockNoData(competitor) {
    return (
        <div className='  d-flex flex-row justify-content-start'>
            <div className=''>
                {competitor?.cp_code !== 'TBD'
                    ? <SportCode discipline={'BOX'} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} />
                    : ''
                }
            </div>
        </div>
    )
}